import { render, staticRenderFns } from "./BookingTypeInfo.vue?vue&type=template&id=baaf0200&scoped=true&"
import script from "./BookingTypeInfo.vue?vue&type=script&lang=ts&"
export * from "./BookingTypeInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BookingTypeInfo.vue?vue&type=style&index=0&id=baaf0200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baaf0200",
  null
  
)

export default component.exports